import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { FetchError } from "ofetch";
import { toast } from "sonner";
import { authApi } from "../api/auth";
import { useUserStore } from "../stores/user";

export function useAuth() {
	const navigate = useNavigate();
	const client = useQueryClient();
	const router = useRouter();

	const sendOTP = useMutation({
		mutationFn: (email: string) => authApi.sendOTP(email),
	});

	const verifyOTP = useMutation({
		mutationFn: async ({ email, otp }: { email: string; otp: string }) => {
			const response = await authApi.verifyOTP(email, otp);
			if (response.data) {
				localStorage.setItem("auth_token", response.data.token);
			}
			return response;
		},
		onSuccess: async () => {
			await client.refetchQueries({ queryKey: ["user", "partial"] });
			await router.invalidate();
		},
		onError: (error) => {
			if (error instanceof FetchError) {
				toast.error(error.data?.message ?? "An error occurred");
				return;
			}
			toast.error(error.message);
		},
	});

	const logout = async () => {
		localStorage.removeItem("auth_token");
		useUserStore.getState().setUser(null);
		await client.resetQueries({ queryKey: ["user", "partial"] });
		router.invalidate().finally(() => {
			navigate({ to: "/login", replace: true });
		});
	};

	return {
		sendOTP,
		verifyOTP,
		logout,
		isAuthenticated: !!localStorage.getItem("auth_token"),
	};
}
